import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { App } from './app/App';
import { languageTag } from './shared/language';

/**
 * The served document already carries the floor language in its `lang`
 * attribute; this makes it follow the resolved one instead of a value baked
 * into the HTML. Today they are the same, and that is the point: when an
 * instance or a client carries a language, `resolveLanguage()` changes and the
 * document, the words and every date change with it, in one place.
 *
 * It matters beyond tidiness. `lang` is what a screen reader picks a voice from
 * and what a browser offers to translate; a Castilian page announced as English
 * is read aloud in an English voice, which is worse than no attribute at all.
 */
document.documentElement.lang = languageTag();

const container = document.getElementById('root');
if (!container) throw new Error('Root element #root is missing from index.html');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
